import { message, Modal } from 'antd'

export const messageType = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
}

export const putMessage = (type, text) => {
  switch (type) {
    case messageType.SUCCESS:
      return success(text)
    case messageType.ERROR:
      return error(text)
    case messageType.INFO:
      return info(text)
    case messageType.WARNING:
      return warning(text)
    default:
      return null
  }
}

export const putDialog = (type, text, title = 'Aviso') => {
  const modalConfig = {
    title,
    content: text,
    maskClosable: false,
    keyboard: false,
  }

  switch (type) {
    case messageType.SUCCESS:
      return Modal.success(modalConfig)
    case messageType.ERROR:
      return Modal.error(modalConfig)
    case messageType.INFO:
      return Modal.info(modalConfig)
    case messageType.WARNING:
      return Modal.warning(modalConfig)
    default:
      return Modal.info(modalConfig)
  }
}

export const success = mensaje => {
  message.success(mensaje)
}

export const error = mensaje => {
  message.error(mensaje)
}

export const info = mensaje => {
  message.info(mensaje)
}

export const warning = mensaje => {
  message.warning(mensaje)
}
